var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.24998H12.75C12.3522 5.24998 11.9706 5.09195 11.6893 4.81064C11.408 4.52934 11.25 4.14781 11.25 3.74998V1.49998M2.25 5.69998V15.3C2.25 15.6182 2.37643 15.9235 2.60147 16.1485C2.82652 16.3736 3.13174 16.5 3.45 16.5H10.8M6.75 13.5C6.35218 13.5 5.97064 13.3419 5.68934 13.0606C5.40804 12.7793 5.25 12.3978 5.25 12V2.99998C5.25 2.60216 5.40804 2.22063 5.68934 1.93932C5.97064 1.65802 6.35218 1.49998 6.75 1.49998H12L15 4.49998V12C15 12.3978 14.842 12.7793 14.5607 13.0606C14.2794 13.3419 13.8978 13.5 13.5 13.5H6.75Z",
    stroke: "#141414",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.b18700fcf739b3aab605cd49122fa94e.svg";
export { ForwardRef as ReactComponent };